import React from "react";
import { observer } from "mobx-react-lite";
import { FormattedMessage } from "react-intl";

const FieldValidation = observer(({ validations, isTransparent }) =>
  validations?.length ? (
    <ul className={`fieldValidation ${isTransparent && "isTransparent"}`}>
      {validations?.map((item, index) => {
        const message = typeof item === "string" ? item : item?.message;

        if (!message) return null;

        return (
          <li key={index}>
            <FormattedMessage id={message} defaultMessage={message} />
          </li>
        );
      })}
    </ul>
  ) : (
    <div />
  )
);

export { FieldValidation };
